import { memo } from "react";
import { Link } from "react-router-dom";

import { PROFILE } from "../../../constants/router";
import { useFilteredMenuItems } from "../../../hooks/useFilteredMenuItems";
import { ClientDropDown } from "../ClientDropDown";
import { TOOLS_ITEMS } from "../Menu.model";
import { RefreshButton } from "../RefreshButton";
import { ToolsDropDown } from "../ToolsDropDown";

export const TrainerMenu = memo(
  ({ closeMenu, closeMenuAndResetEditableClientId }) => {
    const filteredMenu = useFilteredMenuItems();

    return (
      <>
        <div onClick={closeMenuAndResetEditableClientId} className="menu-item">
          <Link to={PROFILE.root} className="tools">
            my profile
          </Link>
        </div>
        <ClientDropDown dropdownItems={filteredMenu} onClick={closeMenu} />
        <ToolsDropDown
          onClick={closeMenuAndResetEditableClientId}
          dropdownItems={TOOLS_ITEMS}
          value="tools"
        />
        <RefreshButton />
      </>
    );
  }
);
